import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { createSharedComposable } from "@vueuse/core";

import {
  LureComplexity,
  SLIDE_OUT,
} from "@/modules/PhishingSimulations/types/schedule-preview";

import type { SlideOutState } from "@/modules/PhishingSimulations/types/schedule-preview";

export const getLureComplexityTranslation = (
  status: LureComplexity | unknown,
) => {
  const { t } = useI18n();

  switch (status) {
    case LureComplexity.easy:
      return t("complexity-easy");

    case LureComplexity.medium:
      return t("complexity-medium");

    case LureComplexity.difficult:
      return t("complexity-difficult");

    default:
      return status;
  }
};

export const useSlideOutState = createSharedComposable(() => {
  const slideOutState = ref<SlideOutState>(SLIDE_OUT);

  const setSlideOutStateState = (newState: SlideOutState) =>
    (slideOutState.value = newState);

  return {
    slideOutState,
    setSlideOutStateState,
  };
});

export const usePreventIframeEvents = () => {
  const lureIframe = ref<HTMLIFrameElement | null>(null);

  const disableLinksAndButtons = () => {
    const iframe = lureIframe.value;

    if (iframe) {
      iframe.onload = () => {
        const iframeDoc =
          iframe.contentDocument || iframe.contentWindow?.document;

        if (iframeDoc) {
          const style = iframeDoc.createElement("style");
          style.textContent = `
              a, button {
                pointer-events: none !important;
                cursor: default !important; /* Optional: visually indicate inactivity */
              }
            `;

          iframeDoc.head.appendChild(style);
        }
      };
    }
  };

  return {
    lureIframe,
    disableLinksAndButtons,
  };
};
